export const CURRENT_SCHEDULE = 'CurrentSchedule';
export const SET_CURRENT_SCHEDULE = 'SetCurrentSchedule';
export const RECENT_SCHEDULES = 'RecentSchedules';
export const SET_RECENT_SCHEDULES = 'SetRecentSchedules';
